import React from 'react';
import { CONTACT } from '@common/constants';

import { cx } from '@emotion/css';

type Props = {
  styles: any;
};

export const ContactItems = ({ styles }: Props) => {
  const requestLink = CONTACT.EMAIL;
  const requestPhone = CONTACT.PHONE;
  const jamesLink = 'james@qeeper.co.uk';
  const requestTrades = CONTACT.TRADES_EMAIL;
  const formLink = '/get-quote';
  const calendlyLink = 'https://calendly.com/qeeper/newbusinessclients';

  const items = [
    {
      title: 'Request a Quote',
      description: (
        <p className={cx(styles.p, styles.contact_item_description)}>
          {' '}
          Need work done? Tell us about your project for a clear , no-obligation
          quote within <br /> 24 hours. We'll detail all costs upfront. Fill out
          our quote{' '}
          <a
            className={cx(styles.link_paragraph)}
            href={formLink}
            target="_blank">
            {' '}
            request form{' '}
          </a>{' '}
        </p>
      ),
    },
    {
      title: 'Book a Service',
      description: (
        <p className={cx(styles.p, styles.contact_item_description)}>
          Ready to Schedule? Book your preferred date and time for routine
          maintenance or repairs. <br />
          Book a service or email us at{' '}
          <a
            className={cx(styles.link_paragraph)}
            href={`mailto:${requestLink}`}>
            {requestLink}
          </a>{' '}
          or call us directly at
          <a className={cx(styles.link_paragraph)} href={`tel:${requestPhone}`}>
            {' '}
            {requestPhone}{' '}
          </a>
        </p>
      ),
    },
    {
      title: 'Customer Service',
      description: (
        <p className={cx(styles.p, styles.contact_item_description)}>
          Questions about an ongoing job or general inquiries? Our support team
          is here <br /> 8am-10pm on weekends and 9am - 6pm on weekends to help.
          Please email us at <br />
          <a
            className={cx(styles.link_paragraph)}
            href={`mailto:${requestLink}`}>
            {requestLink}
          </a>{' '}
          or call us directly at
          <a className={cx(styles.link_paragraph)} href={`tel:${requestPhone}`}>
            {' '}
            {requestPhone}{' '}
          </a>
        </p>
      ),
    },
    {
      title: 'Property Managers',
      description: (
        <p className={cx(styles.p, styles.contact_item_description)}>
          Managing multiple properties? Let's discuss our property management
          solutions <br /> and special portfolio rates. Schedule an Introductory
          call with <b> James </b>{' '}
          <a
            className={cx(styles.link_paragraph)}
            target="_blank"
            href={calendlyLink}>
            {' '}
            here{' '}
          </a>{' '}
          or send an email to{' '}
          <a
            className={cx(styles.link_paragraph)}
            target="_blank"
            href={`mailto:${jamesLink}`}>
            {jamesLink}
          </a>
          .
        </p>
      ),
    },
    {
      title: 'Join Our Team',
      description: (
        <p className={cx(styles.p, styles.contact_item_description)}>
          Interested in joining our team? We're always looking for talended
          individuals to help <br /> us grow. Drop us an email to{' '}
          <a
            className={cx(styles.link_paragraph)}
            href={`mailto:${requestTrades}`}>
            {requestTrades}
          </a>
        </p>
      ),
    },
    {
      title: 'Feedback',
      description: (
        <p className={cx(styles.p, styles.contact_item_description)}>
          Your experience matters. Share your thoughts on your service - praise,
          suggestions, <br />
          or concerns. We're listening. Send your feedback to{' '}
          <a
            className={cx(styles.link_paragraph)}
            href={`mailto:${requestLink}`}>
            {requestLink}
          </a>
        </p>
      ),
    },
  ];

  return (
    <>
      <div className={styles.root}>
        <div className={styles.contact_items_list}>
          {items.map(({ title, description }, index) => (
            <ContactItem
              key={index}
              title={title}
              styles={styles}
              description={description}
            />
          ))}
        </div>
      </div>
    </>
  );
};

const ContactItem = ({ title, description, styles }: any) => {
  return (
    <div className={styles.single_contact_item}>
      <h5 className={styles.h5}> {title} </h5>
      <> {description} </>
    </div>
  );
};
